/**
 * Kortingsaanvraag: connector lead sync + AdCalls form tracking.
 */
(function () {
  function waitForAcalltracker(cb, maxMs) {
    var deadline = Date.now() + (maxMs || 12000);
    (function tick() {
      if (window.acalltracker && typeof window.acalltracker.submitRequest === 'function') {
        cb(window.acalltracker);
        return;
      }
      if (Date.now() >= deadline) {
        cb(null);
        return;
      }
      setTimeout(tick, 100);
    })();
  }

  function getAenCode(form) {
    var code = form.getAttribute('data-ft-aen-code');
    if (code) return code;
    var hidden = form.querySelector('.ft-korting__aen');
    return hidden ? hidden.value : '';
  }

  function postToConnector(form) {
    try {
      var fd = Object.fromEntries(new FormData(form).entries());
      var payload = {
        name: fd['contact[name]'] || '',
        email: fd['contact[email]'] || '',
        telephone: fd['contact[phone]'] || '',
        product: fd['contact[product_title]'] || fd['contact[subject]'] || '',
        product_id: fd['contact[product_id]'] || '',
        product_price: fd['contact[Prijs]'] || '',
        product_category: fd['contact[product_type]'] || '',
        message: fd['contact[body]'] || '',
        referrer: fd['contact[Product-URL]'] || window.location.href,
        gclid: fd['contact[gclid]'] || '',
        fbclid: fd['contact[fbclid]'] || ''
      };
      fetch('https://connector.fonteyn-ai.com/leads/discount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (err) {}
  }

  function populateClickIds(form) {
    var params = new URLSearchParams(window.location.search);
    ['gclid', 'fbclid'].forEach(function (name) {
      var value = params.get(name) || '';
      try {
        if (value) sessionStorage.setItem(name, value);
        else value = sessionStorage.getItem(name) || '';
      } catch (err) {}
      var input = form.querySelector('input[name="contact[' + name + ']"]');
      if (input) input.value = value;
    });
  }

  function bindExpandButtons() {
    document.querySelectorAll('[data-ft-korting-expand]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        var open = !target.hasAttribute('hidden');
        if (open) {
          target.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          btn.querySelector('.ft-korting__expand-icon').textContent = '+';
        } else {
          target.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('.ft-korting__expand-icon').textContent = '−';
          var ta = target.querySelector('textarea');
          if (ta) setTimeout(function () { ta.focus(); }, 50);
        }
      });
    });
  }

  function handleKortingSubmit(e) {
    var form = e.currentTarget;
    if (!form || !form.classList.contains('ft-korting__form')) return;
    if (form.dataset.adcallsDone === '1') return;

    populateClickIds(form);
    postToConnector(form);

    try {
      var ftEmailEl = form.querySelector('input[name="contact[email]"]');
      var ftPhoneEl = form.querySelector('.adcalls-ft-phone');
      var ftNameEl = form.querySelector('input[name="contact[name]"]');
      sessionStorage.setItem('ftKortingLead', JSON.stringify({
        name: ftNameEl ? ftNameEl.value : '',
        email: ftEmailEl ? ftEmailEl.value : '',
        phone: ftPhoneEl ? ftPhoneEl.value : ''
      }));
    } catch (err) {}

    var aenCode = getAenCode(form);
    if (!aenCode) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var phoneInput = form.querySelector('.adcalls-ft-phone');
    var phoneValue = phoneInput ? phoneInput.value : '';
    var formId = form.id || 'contact_form';
    var shopifySubmitted = false;

    function submitToShopify() {
      if (shopifySubmitted) return;
      shopifySubmitted = true;
      var nativeSubmitted = false;
      function submitProtectedForm() {
        if (nativeSubmitted) return;
        nativeSubmitted = true;
        if (phoneInput && phoneValue) phoneInput.value = phoneValue;
        form.dataset.adcallsDone = '1';
        form.submit();
      }
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function') {
        // Shopify requires this callback before a programmatic form.submit().
        captcha.protect(form, submitProtectedForm);
      } else {
        submitProtectedForm();
      }
    }

    waitForAcalltracker(function (tracker) {
      if (!tracker) {
        submitToShopify();
        return;
      }
      tracker.submitRequest(aenCode, formId, function () {
        submitToShopify();
      });
      setTimeout(submitToShopify, 4000);
    });
  }

  function bindKortingForms() {
    document.querySelectorAll('.ft-korting__form').forEach(function (form) {
      populateClickIds(form);
      if (form.dataset.ftKortingBound === '1') return;
      form.dataset.ftKortingBound = '1';
      form.addEventListener('submit', handleKortingSubmit, true);
    });
  }

  function init() {
    bindExpandButtons();
    bindKortingForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
